export default __webpack_public_path__ + "static/media/MSME.81aa3141.png";